var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-expansion-panels',[(_setup.moduleUpdatesLength)?_c('v-expansion-panel',[_c('v-expansion-panel-header',{scopedSlots:_vm._u([{key:"actions",fn:function(){return [_c('v-icon',{attrs:{"color":"primary"}},[_vm._v(" $expand ")])]},proxy:true}],null,false,431335688)},[_vm._v("\n      "+_vm._s(_vm.$t('moduleUpdates'))+" ("+_vm._s(_setup.moduleUpdatesLength)+"):\n    ")]),_vm._v(" "),_c('v-expansion-panel-content',[_c('v-data-table',{attrs:{"headers":[
          {
            text: _vm.$t('account'),
            value: 'assignee.name',
            width: '30px',
          },
          {
            text: _vm.$t('modules'),
            value: 'modulesToAdd',
            width: '30px',
          },
        ],"items":_setup.moduleUpdates},scopedSlots:_vm._u([{key:`item.modulesToAdd`,fn:function({ item }){return [_vm._v("\n          "+_vm._s(_setup.getModulesToAddText(item))+"\n        ")]}}],null,true)})],1)],1):_vm._e(),_vm._v(" "),(_setup.esgQuestionnairesToAddLength)?_c('v-expansion-panel',[_c('v-expansion-panel-header',{scopedSlots:_vm._u([{key:"actions",fn:function(){return [_c('v-icon',{attrs:{"color":"primary"}},[_vm._v(" $expand ")])]},proxy:true}],null,false,431335688)},[_vm._v("\n      "+_vm._s(_vm.$t('esgQuestionnaireAdditions'))+" ("+_vm._s(_setup.esgQuestionnairesToAddLength)+"):\n    ")]),_vm._v(" "),_c('v-expansion-panel-content',[_c('v-data-table',{attrs:{"headers":[
          {
            text: _vm.$t('account'),
            value: 'assignee.name',
            width: '30px',
          },
        ],"items":_setup.esgQuestionnairesToAdd}})],1)],1):_vm._e(),_vm._v(" "),(_setup.assignmentsToAddLength)?_c('v-expansion-panel',[_c('v-expansion-panel-header',{scopedSlots:_vm._u([{key:"actions",fn:function(){return [_c('v-icon',{attrs:{"color":"primary"}},[_vm._v(" $expand ")])]},proxy:true}],null,false,431335688)},[_vm._v("\n      "+_vm._s(_vm.$t('assignmentAdditions'))+" ("+_vm._s(_setup.assignmentsToAddLength)+"):\n    ")]),_vm._v(" "),_c('v-expansion-panel-content',[_c('v-data-table',{attrs:{"headers":[
          {
            text: 'KPI ID',
            value: 'metricId',
            width: '30px',
          },
          {
            text: 'KPI',
            value: 'metric.name',
            width: '30px',
          },
          {
            text: _vm.$t('account'),
            value: 'assignee.name',
            width: '30px',
          },
          {
            text: _vm.$t('why'),
            value: 'why',
            width: '30px',
          },
          {
            text: _vm.$t('hiddenFromAssignee'),
            value: 'hiddenFromAssignee',
            width: '30px',
          },
        ],"items":_setup.assignmentsToAdd},scopedSlots:_vm._u([{key:`item.hiddenFromAssignee`,fn:function({ item }){return [_c('div',{staticClass:"d-flex justify-center"},[(_setup.isHiddenKpi(item))?_c('v-chip',{attrs:{"text-color":"white","color":"danger"}},[_vm._v(_vm._s(_vm.$t('hidden')))]):_c('v-chip',{attrs:{"color":"success"}},[_vm._v(_vm._s(_vm.$t('notHidden')))])],1)]}}],null,true)})],1)],1):_vm._e(),_vm._v(" "),(_setup.fundAggregationsToAddLength)?_c('v-expansion-panel',[_c('v-expansion-panel-header',{scopedSlots:_vm._u([{key:"actions",fn:function(){return [_c('v-icon',{attrs:{"color":"primary"}},[_vm._v(" $expand ")])]},proxy:true}],null,false,431335688)},[_vm._v("\n      "+_vm._s(_vm.$t('aggregationAdditions'))+" ("+_vm._s(_setup.fundAggregationsToAddLength)+"):\n    ")]),_vm._v(" "),_c('v-expansion-panel-content',[_c('v-data-table',{attrs:{"headers":[
          {
            text: 'KPI ID',
            value: 'metricId',
            width: '30px',
          },
          {
            text: 'KPI',
            value: 'metric.name',
            width: '200px',
          },
          {
            text: _vm.$t('why'),
            value: 'why',
            width: '200px',
          },
        ],"items":_setup.fundAggregationsToAdd}})],1)],1):_vm._e(),_vm._v(" "),(_setup.fundAggregationsToDeleteLength)?_c('v-expansion-panel',[_c('v-expansion-panel-header',{scopedSlots:_vm._u([{key:"actions",fn:function(){return [_c('v-icon',{attrs:{"color":"primary"}},[_vm._v(" $expand ")])]},proxy:true}],null,false,431335688)},[_vm._v("\n      "+_vm._s(_vm.$t('aggregationDeletions'))+" ("+_vm._s(_setup.fundAggregationsToDeleteLength)+"):\n    ")]),_vm._v(" "),_c('v-expansion-panel-content',[_c('v-data-table',{attrs:{"headers":[
          {
            text: 'KPI ID',
            value: 'metricId',
            width: '30px',
          },
          {
            text: 'KPI',
            value: 'metric.name',
            width: '200px',
          },
          {
            text: _vm.$t('why'),
            value: 'why',
            width: '200px',
          },
        ],"items":_setup.fundAggregationsToDelete}})],1)],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }